export default __webpack_public_path__ + "static/Graphik-LightItalic-Web-a4022f69a784c9dd4427959dde8401a3.svg";